var React = require('react');

function Card (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.9483 3.99597H5.05234C3.33634 3.99597 1.94434 5.38797 1.94434 7.10397V16.896C1.94434 18.612 3.33634 20.004 5.05234 20.004H18.9483C20.6643 20.004 22.0563 18.612 22.0563 16.896V7.10397C22.0563 5.38797 20.6643 3.99597 18.9483 3.99597ZM20.2563 16.896C20.2563 17.616 19.6683 18.204 18.9483 18.204H5.05234C4.33234 18.204 3.74434 17.616 3.74434 16.896V7.10397C3.74434 6.38397 4.33234 5.79597 5.05234 5.79597H18.9483C19.6683 5.79597 20.2563 6.38397 20.2563 7.10397V16.896ZM5.97634 8.08797H8.97634V9.83997H5.97634V8.08797Z","fill":"black"}));
}

Card.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","className":"icon"};

module.exports = Card;

Card.default = Card;
